/**
 * One composer everywhere (spec 2026-09-20-one-composer-everywhere-design,
 * ruling R-F1). ON: /task and /task/* are dock routes: the Dock (the ball, and
 * the pill behind "or type") is the composer on the task screen, the task
 * layout renders no bottom box and no inline answer card, and an open line
 * survives the route change into a task. OFF: today's task screen, byte for
 * byte. Read at CALL time (never module scope) so tests can stub the env
 * between cases, the task-door-flags.ts pattern. Read as the literal
 * `process.env.NEXT_PUBLIC_…` on purpose: Next inlines that form and no other
 * (the reconciler's web-flag-reads lint says why). Pure: home-flags.ts imports
 * this, and server components import home-flags.ts.
 */
export function isDockOnTaskEnabled(): boolean {
  return process.env.NEXT_PUBLIC_COMPOSER_DOCK_ON_TASK_V1 === "true";
}
